import { configureStore } from "@reduxjs/toolkit";
import alertMessage from "../Slice/alertMessage";
import { rtkQueryErrorLogger } from "../Slice/errorLogger";

const store = configureStore({
  reducer: {
    alertMessage: alertMessage,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkQueryErrorLogger),
});

export default store;
